import {DebugVerbosityLevel, ResumableConfiguration} from "./types/types";

/**
 * Defaults that will be used when the values are not provided at creation of the Resumable object.
 * However, the callbacks (e.g. `maxFilesErrorCallback`) will be set to default functions inside `resumable.ts` if they
 * are not provided.
 */
export const DefaultConfiguration: ResumableConfiguration = {
  target: '/',
  chunkSize: 1024 * 1024,
  clearInput: false,
  dragOverClass: 'dragover',
  simultaneousUploads: 3,
  fileParameterName: 'file',
  chunkNumberParameterName: 'resumableChunkNumber',
  totalChunksParameterName: 'resumableTotalChunks',
  throttleProgressCallbacks: 0.5,
  chunkSizeParameterName: 'resumableChunkSize',
  totalSizeParameterName: 'resumableTotalSize',
  identifierParameterName: 'resumableIdentifier',
  fileCategoryParameterName: 'resumableFileCategory',
  fileNameParameterName: 'resumableFilename',
  relativePathParameterName: 'resumableRelativePath',
  currentChunkSizeParameterName: 'resumableCurrentChunkSize',
  typeParameterName: 'resumableType',
  debugUploadTaskIdParameterName: 'resumableDebugUploadTaskId',
  debugIsFinalCheckParameterName: 'resumableDebugIsFinalCheck',
  query: {},
  testMethod: 'GET',
  uploadMethod: 'POST',
  parameterNamespace: '',
  headers: {},
  method: 'multipart',
  testChunks: true,
  generateUniqueIdentifier: null,
  maxFiles: undefined,
  maxFilesErrorCallback: () => {},
  minFileSize: 1,
  minFileSizeErrorCallback: () => {},
  maxFileSize: undefined,
  maxFileSizeErrorCallback: () => {},
  fileCategories: [],
  defaultFileCategory: 'default',
  fileTypes: [],
  fileTypeErrorCallback: () => {},
  fileValidationErrorCallback: () => {},
  maxChunkRetries: 100,
  chunkRetryInterval: undefined,
  chunkStuckTimeout: undefined,
  permanentErrors: [400, 401, 403, 404, 409, 415, 500, 501],
  withCredentials: false,
  xhrTimeout: 0,
  chunkFormat: 'blob',
  setChunkTypeFromFile: false,
  testTarget: '',
  debugVerbosityLevel: DebugVerbosityLevel.NONE,
  includeDebugRequestParameters: false,
}
